import { IUpdateObraPlanoTreinamentoUseCase } from "../../../presentation/useCases/update/update_plano_treinamento_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateObraEstruturaOrganizacionalUseCase
 */

export class UpdateObraPlanoTreinamentoUseCase implements IUpdateObraPlanoTreinamentoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateObraPlanoTreinamento(
    idObra: number,
    IdPlanoTreinamento: number,
    Cargo: string,
    TipoTreinamento: string
  ): Promise<void> {
    await this.repository.updateObraPlanoTreinamento(
     idObra, IdPlanoTreinamento, Cargo, TipoTreinamento
    );
  }
}
